var $ea7f03899a1c8e61$exports = {};
$ea7f03899a1c8e61$exports = {
    "valid": `Valid`
};


export {$ea7f03899a1c8e61$exports as default};
//# sourceMappingURL=fi-FI.mjs.map
